import React, { Component } from 'react';
import { DeviceEventEmitter, TouchableOpacity } from 'react-native';
import RenderDataHTML from './render-data-html';

import styles from './learn-today-horizontal';



const COLORS = [
  '#FFF1E1',
  '#E9FFE1',
  '#E1F3FF',
  '#E1E2FF',
  '#E1FFFD',
  '#F5E1FF',
  '#FFE1EC',
  '#FFF7E1',
];

export default class VpttypesHorizontal extends Component {

  

  onNavigateDetail = () => {
    const { navigation, item, screenname } = this.props;

   console.log("The screen name is",screenname);
    //const navigation = useNavigation();
   
    if(screenname !='districts'){
   
    if (item.name == 'Students') {
      navigation.navigate('StudentPrograms', item.id);
    } 
   else if (item.name == 'Academic Subjects') {
    const reqdata = {
      branchid: '',
      semisterid: '',
      academictypeid: '',
      universityid: '',
      searchname:''
  }

      navigation.navigate('academicsearch', { item: reqdata });
    }
    else if (item.name =='Employability skills') {
      //DeviceEventEmitter.emit('refresh_with_category_programs2', 'CRT');
      navigation.navigate("courseprogram", { keyid: item.id ,keyname :item.name });

    } 
    else if(screenname =='EXAMCHANGE'){
      
     DeviceEventEmitter.emit('changesubjectquestions',item);
     
     
   } else if(screenname =='REVIEWEXAMCHANGE'){
      
    DeviceEventEmitter.emit('examchangesubjectquestions',item);
    

  }
    else {

      if(screenname =='guidencepogram'){
       // DeviceEventEmitter.emit('refresh_with_category_programs1', item.id);
        navigation.navigate("courseprogram", { gkeyid: item.id ,keyname:'Non IT Courses'});

      }
      
      
      else{
       // alert("navigation");
      navigation.navigate(screenname, { keyid: item.id });
      }
    }
  }else{


     DeviceEventEmitter.emit('policalsubappid3', item.id,item.twitterid,item.facebookid,item.name)

     DeviceEventEmitter.emit('nameupdatesubapp',item.name)

     DeviceEventEmitter.emit('activityemitterid',item.id)

   
    
   /* Alert.alert(
      //title
      'Constituency Updates',
      //body
      'You are about to view updates of '+item.name+' do you want to proceed?',
      [
          { text: 'Yes', onPress: () =>{ DeviceEventEmitter.emit('policalsubappid3', item.id,item.twitterid,item.facebookid,item.name)} },
          {
              text: 'No',
              onPress: () => console.log('No Pressed'),
              style: 'cancel',
          },
      ],
      { cancelable: false }
      //clicking out side of alert will not cancel
  );*/
   
  }
    // DeviceEventEmitter.emit('focus', item.id);

  };

  generateColor = () => {
    return `${COLORS[Math.floor(Math.random() * COLORS.length)]}`;
  };

  render() {
    const { item, screenname } = this.props;
    console.log(screenname);
    return (
      <TouchableOpacity
        onPress={this.onNavigateDetail}
        style={[styles.container, { backgroundColor: this.generateColor() }]}
      >
        <RenderDataHTML html={item.name} style={styles.title} />
        
      </TouchableOpacity>
    );
  }
}
